import { render, staticRenderFns } from "./AddOrEditServicePoint.vue?vue&type=template&id=2c167930"
import script from "./AddOrEditServicePoint.vue?vue&type=script&lang=ts"
export * from "./AddOrEditServicePoint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports